import * as React from 'react'

export type CalendarCellsPlaceholderProps = {
  rows: number
  columns: number
  height: number
  width: number
  shimmer?: boolean
}

export const CalendarCellsPlaceholder: React.FC<
  CalendarCellsPlaceholderProps
> = ({ rows, columns, height, width, shimmer = false }) => {
  const rowIndexes = React.useMemo(
    () => Array.from({ length: rows }, (_, i) => i),
    [rows],
  )
  const columnIndexes = React.useMemo(
    () => Array.from({ length: columns }, (_, i) => i),
    [columns],
  )

  return (
    <div className="tw-flex tw-flex-col">
      {rowIndexes.map((rowIndex) => (
        <div key={rowIndex} className="tw-flex">
          {columnIndexes.map((columnIndex) => (
            <div
              key={columnIndex}
              style={{
                width,
                height,
                borderStyle: 'solid',
                borderLeftWidth: 1,
                borderTopWidth: rowIndex === 0 ? 1 : 0,
                borderBottomWidth: 1,
                borderRightWidth: columnIndex === columns - 1 ? 1 : 0,
                borderColor: 'var(--color-border-base-300, #e5e7eb)',
                background: '#FFFFFF',
              }}
              className="tw-relative tw-overflow-hidden"
            >
              {shimmer && (
                <div className="tw-flex tw-h-full tw-animate-pulse tw-flex-col tw-justify-between tw-p-1">
                  <div className="tw-h-2 tw-w-2.5 tw-rounded tw-bg-base-300" />
                  <div className="tw-flex tw-flex-col tw-gap-1">
                    <div className="tw-h-2 tw-w-full tw-bg-base-300" />
                    <div className="tw-h-2 tw-w-2/3 tw-bg-base-200" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
